import { render, staticRenderFns } from "./EmptyBlockControl.vue?vue&type=template&id=38cde41c"
import script from "./EmptyBlockControl.vue?vue&type=script&lang=js"
export * from "./EmptyBlockControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports